var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_1_5",
    "data-name": "1,5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1263a9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "password") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M400,512H112a48.06,48.06,0,0,1-48-48V240a48.06,48.06,0,0,1,48-48H400a48.06,48.06,0,0,1,48,48V464A48.06,48.06,0,0,1,400,512ZM112,224a16,16,0,0,0-16,16V464a16,16,0,0,0,16,16H400a16,16,0,0,0,16-16V240a16,16,0,0,0-16-16Z",
    transform: "translate(-64)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368,224a16,16,0,0,1-16-16V128a96,96,0,1,0-192,0v80a16,16,0,1,1-32,0V128a128,128,0,0,1,256,0v80A16,16,0,0,1,368,224Z",
    transform: "translate(-64)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,362.67A42.67,42.67,0,1,1,298.67,320,42.71,42.71,0,0,1,256,362.67Zm0-53.33A10.67,10.67,0,1,0,266.67,320,10.68,10.68,0,0,0,256,309.33Z",
    transform: "translate(-64)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,426.67a16,16,0,0,1-16-16V352a16,16,0,1,1,32,0v58.67A16,16,0,0,1,256,426.67Z",
    transform: "translate(-64)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.0a526fa10b4c8c4422d22fd10bc2755b.svg";
export { ForwardRef as ReactComponent };